import { SxProps, Theme } from '@mui/material';

export const SECTION_LABEL_SX: SxProps<Theme> = {
  fontSize: '13px',
  fontWeight: 600,
  mb: 0.5,
};

export const SECTION_SUBLABEL_SX: SxProps<Theme> = {
  fontSize: '12px',
  color: 'text.secondary',
  mb: 0.5,
};

export const SECTION_LOCK_SX: SxProps<Theme> = {
  fontSize: '12px',
  color: 'text.disabled',
  fontStyle: 'italic',
  mb: 0.5,
};

export const FORM_MAX_WIDTH = 760;
